export const numberFormats = {
	en: {
		currency: {
			style: 'currency',
			currency: 'USD',
		},
		integer: {
			style: 'decimal',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		float: {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		percent: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		percent_decimal: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
	},
	fr: {
		currency: {
			style: 'currency',
			currency: 'EUR',
		},
		integer: {
			style: 'decimal',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		float: {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		percent_decimal: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		percent: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
	},
	de: {
		currency: {
			style: 'currency',
			currency: 'EUR',
		},
		integer: {
			style: 'decimal',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		float: {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		percent_decimal: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		percent: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
	},
}

export const datetimeFormats = {
	en: {
		short: {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
		},
		long: {
			year: '2-digit',
			month: 'short',
			day: 'numeric',
		},
	},
	fr: {
		short: {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
		},
		long: {
			year: '2-digit',
			month: 'short',
			day: 'numeric',
		},
	},
	de: {
		short: {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
		},
		long: {
			year: '2-digit',
			month: 'short',
			day: 'numeric',
		},
	},
}

export default defineI18nConfig(() => ({
	legacy: false,
	allowHtml: true,
	fallbackLocale: 'en',
	datetimeFormats,
	numberFormats,
}))
